// Route Code Edited 3/30/26
/**
 * Route Button Attribute Handler
 *
 * Watches for configured buttons in the DOM and enforces class/attribute
 * additions, removals, and replacements via MutationObserver.
 * Useful for stripping third-party app markers from checkout buttons.
 *
 * Each entry in BUTTON_CONFIGS targets a selector independently.
 * attrs: { 'attr-name': 'value' }  → set/replace
 * attrs: { 'attr-name': null }     → remove
 */

(function routeButtonHandler() {

  // ─── Configure below ──────────────────────────────

  const BUTTON_CONFIGS = [
    {
      selector: '[data-route-cloned-button]',
      classesToRemove: [],
      classesToAdd: [],
      attrs: {
        'type': 'button',
        'form': null,
        'name': null,
        'data-original-display': null,
      },
    },
  ];

  // ───────────────────────────────────────────────────

  function hasUnwantedMarkers(btn, config) {
    return (
      config.classesToRemove.some(c => btn.classList.contains(c)) ||
      config.classesToAdd.some(c => !btn.classList.contains(c)) ||
      Object.entries(config.attrs).some(([a, v]) =>
        v === null ? btn.hasAttribute(a) : btn.getAttribute(a) !== v
      )
    );
  }

  function applyChanges(btn, config, observer) {
    observer.disconnect();

    config.classesToRemove.forEach(c => btn.classList.remove(c));
    config.classesToAdd.forEach(c => btn.classList.add(c));
    Object.entries(config.attrs).forEach(([a, v]) =>
      v === null ? btn.removeAttribute(a) : btn.setAttribute(a, v)
    );

    observer.observe(btn, {
      attributes: true,
      attributeFilter: ['class', ...Object.keys(config.attrs)],
    });
  }

  function watchButton(btn, config) {
    if (btn._routeHandlerWatched) return;
    btn._routeHandlerWatched = true;

    const observer = new MutationObserver(() => {
      if (hasUnwantedMarkers(btn, config)) applyChanges(btn, config, observer);
    });

    applyChanges(btn, config, observer);
  }

  function scanButtons() {
    BUTTON_CONFIGS.forEach(config =>
      document.querySelectorAll(config.selector).forEach(btn => watchButton(btn, config))
    );
  }

  // Only scan when nodes are actually added to the DOM
  const domObserver = new MutationObserver(mutations => {
    if (mutations.some(m => m.addedNodes.length > 0)) scanButtons();
  });

  domObserver.observe(document.body, { childList: true, subtree: true });
  scanButtons();

  window.addEventListener('pagehide', () => domObserver.disconnect());
})();